import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const getAvailableGranularities = (durationObj, webSource: string = devicesTypes.DESKTOP) => {
    const durationRaw = durationObj?.raw;
    const monthDiff = durationRaw.to.diff(durationRaw.from, "month");
    return [
        {
            title: "D",
            disabled: true,
            index: 0,
            value: "Daily",
        },
        {
            title: "W",
            disabled: webSource === devicesTypes.TOTAL,
            index: 1,
            value: "Weekly",
        },
        {
            title: "M",
            disabled: webSource !== devicesTypes.TOTAL && monthDiff < 1,
            index: 2,
            value: "Monthly",
        },
    ];
};
